import { useState, useCallback, useEffect } from 'react';
import { WindState } from '../types';
import { normalizeAngle } from '../engine/geometry';

export function useWind(initialWind: WindState) {
  const [wind, setWind] = useState<WindState>(initialWind);

  const updateWind = useCallback((deltaTime: number) => {
    setWind((prev) => {
      let newDirection = prev.direction;
      if (prev.targetDirection !== prev.direction) {
        const diff = normalizeAngle(prev.targetDirection - prev.direction);
        const shift =
          Math.sign(diff) * Math.min(Math.abs(diff), prev.shiftRate * deltaTime);
        newDirection = normalizeAngle(prev.direction + shift);
      }

      const gustNoise = (Math.random() - 0.5) * 0.02;
      const newGustFactor = Math.max(
        0.85,
        Math.min(1.2, prev.gustFactor + gustNoise)
      );

      return {
        ...prev,
        direction: newDirection,
        gustFactor: newGustFactor,
      };
    });
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setWind((prev) => ({
        ...prev,
        targetDirection: normalizeAngle(
          prev.direction + (Math.random() - 0.5) * 0.4
        ),
        shiftRate: 0.05 + Math.random() * 0.1,
      }));
    }, 15000 + Math.random() * 15000);

    return () => clearInterval(interval);
  }, []);

  return { wind, updateWind, setWind };
}
